import React, {useCallback, useMemo, useRef} from 'react'
import {useContext} from 'reactn'
import {NewCalendarContext} from '../../../context/NewCalendar'
import './MonthDates.styles.scss'
import moment from 'moment'
import eventsData from './../events-fixtures.json'
import EventItem from './EventItem'
import _ from 'lodash'
import ApMath from '../../../utils/ApMath'
import useCalendarEvents from './../useCalendarEvents'
import WeekRow from './WeekRow'
import {ReservationCalendarMainContext} from '../../../context/ReservationCalendarMain'
import useMonthReserveAction from './useMonthReserveAction'

export default function MonthDates({onNavigate = () => {}, onClickEvent = () => {}}) {
  const hoursInMS = 60 * 60 * 1000
  const {
    calendarView,
    dateWiseData,
    setNavigatedDate,
    handleSidebarData,
    navigatedDate,
    realSearch,
    isSameDate,
    sidebarDateClicked,
    setSidebarDateClicked,
  } = useContext(ReservationCalendarMainContext)
  const {events, selectedDate} = useCalendarEvents()

  const ref = useRef()
  let startOfMonthCalendar = useMemo(
    () =>
      selectedDate
        .clone()
        .startOf('month')
        .startOf('week'),
    [selectedDate]
  )
  let firstDay = moment(selectedDate)
    .startOf('month')
    .day()
  let lastDay = moment(selectedDate)
    .clone()
    .endOf('month')
    .day()
  let daysInMonth = selectedDate.daysInMonth()
  let findWeek = Math.ceil((firstDay + daysInMonth) / 7)
  // eslint-disable-next-line
  let weeksInMonth = []

  for (let i = 1; i <= findWeek; i++) {
    weeksInMonth.push(i)
  }

  let daysInWeek = [0, 1, 2, 3, 4, 5, 6]
  const getLastMonthDate = day => {
    return moment(selectedDate)
      .startOf('month')
      .subtract(firstDay - day, 'days')
      .date()
  }
  const getNextMonthDate = day => {
    return moment(selectedDate)
      .endOf('month')
      .add(day - lastDay, 'days')
      .date()
  }
  const getDay = useCallback(
    (week, day) => {
      if (week === 1) {
        if (day < firstDay) {
          return getLastMonthDate(day)
        } else if (day === firstDay) {
          return 1
        } else {
          return day - firstDay + 1
        }
      } else if (week > 1 && week < weeksInMonth.length) {
        return 7 - firstDay + day + 1 + (week - 2) * 7
      } else if (week === weeksInMonth.length) {
        if (day <= lastDay) {
          return 7 - firstDay + day + 1 + (week - 2) * 7
        } else {
          return getNextMonthDate(day)
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedDate, firstDay, weeksInMonth]
  )

  const [weekEvents] = useMemo(() => {
    const dayInMS = 60 * 60 * 24 * 1000

    let selDateStart = selectedDate
      .clone()
      .startOf('month')
      .subtract(firstDay, 'days')
    let selDateEnd = selectedDate.clone().endOf('month')

    let weekEvents = {}
    Array.from({length: weeksInMonth.length}).forEach((e, i) => {
      const index = selDateStart
        .clone()
        .add(i * 7, 'days')
        .valueOf()
      weekEvents[index] = []
    })

    events.data.forEach(ev => {
      const start_date = moment(ev.start)
      let real_end = moment(ev.end)
      const end_date = moment(ev.action_return_date || ev.end)

      Object.keys(weekEvents).forEach(week => {
        if (
          !ApMath.isRangeOverlap(
            moment(Number(week))
              .startOf('week')
              .valueOf(),
            moment(Number(week))
              .endOf('week')
              .valueOf(),
            start_date
              .clone()
              .startOf('day')
              .valueOf(),
            end_date
              .clone()
              .startOf('day')
              .valueOf()
          )
        ) {
          return 0
        }

        let eventDateRef = moment(
          Math.max(
            start_date.valueOf(),
            moment(Number(week))
              .startOf('week')
              .valueOf()
          )
        )
          .startOf('week')
          .valueOf()

        let top = ((start_date.valueOf() - eventDateRef) / dayInMS) * 100
        let bottom = ((end_date.valueOf() - eventDateRef) / dayInMS) * 100
        let min = 0
        let max = 100

        if (top < min || bottom >= max) {
          if (!weekEvents[eventDateRef]) {
            weekEvents[eventDateRef] = []
          }

          weekEvents[eventDateRef].push({
            event: ev,
          })
        }

        weekEvents[eventDateRef].push({
          event: ev,
        })
      })
    })
    // CreateEventGroupings(events)
    weekEvents = _.map(weekEvents, events => events)
    return [weekEvents]
  }, [events, firstDay, selectedDate, weeksInMonth.length])

  const rowCount = useMemo(() => {
    const el = document.querySelector('.month-main')
    if (!el) return 2
    const rect = el.getBoundingClientRect()
    const h = rect.height / weekEvents.length
    return Math.floor((h - 20 - 23) / 21)
  }, [weekEvents])

  const getWeekStart = i => {
    return selectedDate
      .clone()
      .startOf('month')
      .subtract(firstDay, 'days')
      .clone()
      .add(i * 7, 'days')
      .valueOf()
  }

  const getDate = (week, day) => {
    return selectedDate
      .clone()
      .startOf('month')
      .subtract(firstDay, 'days')
      .clone()
      .add(week * 7 + day, 'days')
      .valueOf()
  }

  useMonthReserveAction(startOfMonthCalendar, weekEvents.length)

  const rangeSort = eventList => {
    return eventList.sort((a, b) => {
      return a.end.diff(a.start, 'days') > b.end.diff(b.start, 'days') ? -1 : 1
    })
  }

  const dateSort = eventList => {
    return eventList.sort((a, b) => {
      return a.start < b.start ? -1 : 1
    })
  }

  const getFormatedDate = date => {
    return date.format('MM/DD/YYYY')
  }

  const setIndexing = (eventList, prevEventData) => {
    return eventList.forEach((event, j) => {
      if (!_.isEmpty(event)) {
        var prev_index1 = prevEventData && prevEventData.indexOf(event)
        event.previous_index = prev_index1
        event.current_index = j
      }
    })
  }

  const addBlankObjToDayEvent = (dayEvents, rowCount) => {
    while (dayEvents.length >= 1 && dayEvents.length < rowCount) {
      dayEvents.push({})
    }
  }

  const getDayEvents = (newDayEvents, day_event, curr_date) => {
    if (
      curr_date >= getFormatedDate(day_event.start) &&
      curr_date <= getFormatedDate(day_event.end)
    ) {
      newDayEvents.push(day_event)
      rangeSort(newDayEvents)
      dateSort(newDayEvents)
    }
    return newDayEvents
  }

  const getArrangedDayEvents = (dayEvents, currentDayEvents) => {
    return dayEvents.forEach((event, j) => {
      event.current_index = j
      if (event.previous_index === j) {
        currentDayEvents[event.current_index] = event
      } else if (event.previous_index !== j) {
        event.previous_index >= 0
          ? (currentDayEvents[event.previous_index] = event)
          : currentDayEvents[0] === undefined
          ? (currentDayEvents[0] = event)
          : currentDayEvents[1] === undefined
          ? (currentDayEvents[1] = event)
          : currentDayEvents[2] === undefined
          ? (currentDayEvents[2] = event)
          : currentDayEvents[3] === undefined && (currentDayEvents[3] = event)
      }
    })
  }

  return (
    <div
      ref={ref}
      className="ap-no-select month-scroller"
      data-x="month-reserve"
      style={{
        overflowY: 'auto',
        maxHeight: '670px',
        position: 'relative',
        overflowX: 'hidden',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {weeksInMonth.map(week => {
        return (
          <>
            <div className="month-row m-auto">
              {daysInWeek.map(day => {
                return <div className="month-col day-cell m-auto"></div>
              })}
              <div
                style={{
                  zIndex: 100,
                  position: 'absolute',
                  width: '100%',
                }}
              ></div>
            </div>
          </>
        )
      })}
      <div className="month-main">
        {weekEvents.map((evts, i) => (
          <>
            <div className="month-row m-auto">
              <div className="event-row month-row">
                {daysInWeek.map(day => {
                  var curr_date = getFormatedDate(moment(getDate(i, day)))
                  var pre_date = getFormatedDate(
                    moment(getDate(i, day))
                      .subtract(1, 'days')
                      .startOf('day')
                  )
                  let dayEvents = []
                  let preDayEvents = []
                  var currentDayEvents = []

                  events.data.forEach(day_event => {
                    !events.prevdata
                      ? getDayEvents(preDayEvents, day_event, pre_date)
                      : preDayEvents.push(events.prevdata)
                  })

                  events.newprevcurrentDayEvents = events.prevcurrentDayEvents

                  events.data.forEach((day_event, index1) => {
                    getDayEvents(dayEvents, day_event, curr_date)
                  })

                  setIndexing(dayEvents, events.prevdata)
                  // for 4 events per day
                  addBlankObjToDayEvent(dayEvents, rowCount)
                  getArrangedDayEvents(dayEvents, currentDayEvents)

                  events.prevdata = currentDayEvents
                  events.prevcurrentDayEvents = currentDayEvents

                  return (
                    <div className="month-col">
                      <span
                        style={{cursor: 'pointer'}}
                        onClick={ev => onNavigate(ev, getDate(i, day), events)}
                      >
                        {getDay(i + 1, day)}
                      </span>
                      <WeekRow
                        week={getWeekStart(i)}
                        onNavigate={onNavigate}
                        allEvents={events}
                        onClickEvent={onClickEvent}
                        current_date={curr_date}
                        week_day={day}
                        dayEvents={dayEvents}
                        currentDayEvents={currentDayEvents.filter(function(el) {
                          return el !== null
                        })}
                        preDayEvents={events.newprevcurrentDayEvents}
                        rowCount={rowCount}
                      />
                    </div>
                  )
                })}
              </div>
            </div>
          </>
        ))}
      </div>
    </div>
  )
}
